<kui-modal size="lg" class="console-modal" [title]="'ADMIN.EDITORS.DEVICE.CONSOLE.TITLE' | translate" (onClose)="detachModal()" [actions]="modalActions">
    <div class="console-content d-flex flex-column">
        <div class="console flex-1">
            @for (line of lines; track line) {
                <div>{{ line }}</div>
            }
        </div>
        @if (!!ws) {
            <div class="text">
                <input kui-input [placeholder]="'ADMIN.EDITORS.DEVICE.CONSOLE.TEXT_TIP' | translate" [(ngModel)]="text" (keydown.enter)="onSend($event)" />
            </div>
        }
    </div>
</kui-modal>
